<template>
	<div id="wrapper">
		<SidebarView :members="true" :all-member="true" :member-visible="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<!-- begin row  -->
					<div class="row">
						<div class="col-lg-12">
							<div class="card card-shape home-box">
								<div class="card-header">
									<div class="d-flex justify-content-between align-items-center">
										<div>
											<h6 class="m-0 fw-bold text-green">All Members</h6>
										</div>
										<div>
											<b-button size='sm' class="akkurate-green-btn btn-size" href="/members/create" variant="primary">
												<span class="akkurate-small"> <i class="fas fa-plus"></i> Add
													Member</span>
											</b-button>
											<b-link title="Excel Export" @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
												<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
										</div>
									</div>
								</div>
								<div class="card-body default_bg" style="border-bottom: 1px solid rgb(1, 134, 115);">
									<div class="home-box border border-success py-1 bg-white">
										<div class="card-body">
											<!-- <member-filter :form="form" :filterTable="filterTable"></member-filter> -->
											<form @submit.prevent="filterTable()">
												<div class="row">
													<div class="col-12 col-md-6">
														<label class="akkurate-dark small d-none d-lg-block" for="search_term">Search Term</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mt-2 field-container fields" type="text" v-model="form.search_term" placeholder="Search by firstname, lastname, phone number, email, staff ID">
															</b-form-input>
														</b-form-group>
													</div>

													<div class="col mb-2 mb-md-0">
														<label class="akkurate-dark small d-none d-lg-block" for="type">Status</label>
														<multiselect class="mt-2 field-container" v-model="form.status" :options="status_option">
														</multiselect>
													</div>
													<div class="col mb-2 mb-md-0">
														<label class="akkurate-dark small d-none d-lg-block" for="type">Gender</label>
														<multiselect class="mt-2 field-container" v-model="form.gender" :options="form.gender_option">
														</multiselect>
													</div>
													<div class="d-grid gap-2 col-md-2 d-flex align-content-center justify-content-center mt-auto ">
														<b-button type="submit" class="akkurate-green-btn akkurate-auth-size w-100 d-flex align-items-center justify-content-center"><i class="fas fa-search "></i><span class="d-none d-lg-block ms-2">Search</span></b-button>
														<b-button size="sm" v-b-modal.modal-member title="show more filters" class="ms-2">
															<i class="fas fa-bars akkurate-small"></i>
														</b-button>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>
								<div class="card-body px-0 pt-0">
									<div class="table_text_size">
										<b-table striped bordered responsive id="member-table" :busy.sync="isBusy" :items="rows" :fields="fields" :tbody-tr-class="rowClass" show-empty>

											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<template #empty="scope">
												<h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
											</template>
											<template #cell(index)="data">
												{{ data.index + 1 }}
											</template>
											<template #cell(code)="data">
												<CustomTooltip :message="getMemInfo(data.item)" :is-html="true" :background="'#2153566e'" :color="'#fff'" :offsetY="30" :max-width="'600px'">
													{{ data.item.code }}
												</CustomTooltip>
												<!-- <span v-else>
													{{ data.item.code }}
												</span> -->
											</template>
											<!-- A custom formatted column -->
											<template #cell(customer)="data">
												<CustomTooltip :message="getMemInfo(data.item)" :is-html="true" :background="'#2153566e'" :color="'#fff'" :offsetY="30" :max-width="'600px'">
													{{ data.item.first_name }} {{ data.item.last_name }}
												</CustomTooltip>
											</template>

											<template #cell(digital_address)="data">
												<CustomTooltip :message="getLocationDisplayMessage(data.item)" :is-html="true" :background="'#2153566e'" :color="'#fff'" :offsetY="30" :max-width="'600px'">

													<div @click="showMap(data.item)" class="custom-pointer">
														{{ data.item.digital_address }}
													</div>
												</CustomTooltip>
											</template>
											<template #cell(status)="data">
												<span v-if="data.item.get_pending_request_member_edit.length > 0" :class="statusBadge(data.item)">Pending Edit</span>
												<span v-else :class="statusBadge(data.item)">{{ data.item.status
												}}</span>
											</template>
											<template #cell(actions)="data">
												<span class="d-flex">
													<a title="View" class="btn btn-sm akkurate-warning text-white broder-0 custom-pointer" @click="showCustomerViewModal(data.item.id, institution)">
														<span class="akkurate-small"> <font-awesome-icon :icon="['fas', 'eye']" /></span>
													</a>
													<a title="Delete" class="btn btn-sm akkurate-danger-btn text-white border-0 custom-pointer" @click="deleteMember(data.item)" variant="primary">
														<span class="akkurate-small"> <i class="fas fa-trash"></i></span>
													</a>

													<a title="Approve Edit" v-if="data.item.get_pending_request_member_edit.length > 0" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" @click="approveEdit(data.item)">
														<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'check']" /></span>
													</a>

													<!--  -->

													<div class="dropdown no-arrow d-inline custom-pointer">
														<a title="More Actions" class="btn btn-sm akkurate-gray-btn text-white dropdown-toggle " id="dropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<span class="akkurate-small"> <font-awesome-icon :icon="['fas', 'ellipsis']" /></span>
														</a>
														<!-- Added dropdown-menu-end to ensure the menu appears outside -->
														<!-- <div class="dropdown-menu dropdown-menu-end shadow animated--fade-in" aria-labelledby="dropdownMenu">
															<div class="dropdown-header py-2">Status</div>
															<b-button v-if="data.item.status != 'Active'" class="dropdown-item" @click="setUserStatus('Active', data.item)"><span class="small">Active</span></b-button>
															<b-button v-if="data.item.status != 'Inactive'" class="dropdown-item" @click="setUserStatus('Inactive', data.item)"><span class="small">Inactive</span></b-button>
															<b-button v-if="data.item.status != 'Dormant'" class="dropdown-item" @click="setUserStatus('Dormant', data.item)"><span class="small">Dormant</span></b-button>
														</div> -->
														<div class="dropdown-menu">
															<a title="Edit" class=" dropdown-item border-0 px-1" :href="`/members/${data.item.id}/edit`">
																<span class="akkurate-small btn btn-sm akkurate-blue text-white me-2"><font-awesome-icon :icon="['fas', 'edit']" /></span>Edit
															</a>

															<!-- <a title="Status" class="dropdown-item border-0 px-1">
																<span class="akkurate-small btn btn-sm akkurate-green-btn text-white me-2"><font-awesome-icon :icon="['fas', 'user']" /></span>Status
															</a> -->
															
															<a title="Reset PIN" class="dropdown-item border-0 custom-pointer px-1" @click="resetPIN(data.item)">
																<span class="akkurate-small btn btn-sm akkurate-gray-btn text-white me-2"><font-awesome-icon :icon="['fas', 'key']" /></span>Reset Pin
															</a>
															<div class="dropdown-divider my-1"></div>
															<a class="dropdown-item px-1" @click="showSendSmsModal(data.item)">
																<span class="akkurate-small btn btn-sm akkurate-blue text-white me-2"><font-awesome-icon :icon="['fas', 'paper-plane']" /></span>Send SMS
															</a>
															<div class="dropdown-divider my-1"></div>
															<a title="All Statements" class="dropdown-item border-0 px-1" @click="showAllStatementModal(data.item.id, institution)">
																<span class="akkurate-small btn btn-sm akkurate-gray-btn text-white me-2"><font-awesome-icon :icon="['fas', 'book']" /></span>All Statements
															</a>
														</div>
													</div>

													<!--  -->
													<!-- <a title="Send Sms"
														class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer"
														v-b-modal.send-mail>
														<span class="akkurate-small"><font-awesome-icon
																:icon="['fas', 'mail-forward']" /></span>
													</a> -->
												</span>
											</template>
										</b-table>

										<div class="d-flex justify-content-between px-3 pb-3">
											<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" aria-controls="member-table"></b-pagination>
											<div class="col text-end mt-1 akkurate-dark">
												<div>
													{{ currentPage }} -
													{{ perPage }} of
													{{ totalRecords }}
												</div>
												<b-form-group label="Per Page" label-size="sm" class="mb-0">
													<b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage" :options="per_page_options
														" size="sm"></b-form-select>
												</b-form-group>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<MapModal :coords="coords" :modal-id="'map-modal-1'" :digitalAddress="digitalAddress" :memberInfo="selectedMemberInfo" />
					<!-- end row  -->

					<b-modal size="xxl" id="bv-modal-customer-view" hide-footer>
						<template #modal-title>
							<h6 class="m-0 fw-bold text-green text-sm">Member View</h6>
						</template>
						<member-view :id="member_id" :institution="institution"></member-view>
					</b-modal>

					<!-- Send SMS Modal -->
					<send-sms-form v-if="selectedCustomerId != null" :customer-id="selectedCustomerId"
						:customer-phone-hint="selectedCustomerPhoneHint" @modal-hidden="selectedCustomerId = null" />

					<b-modal size="md" id="modal-member" @ok="handleOk">
						<template #modal-title>
							<h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
						</template>
						<member-filter :form="form" :filterTable="filterTable" :trans_source_options="trans_source_options" :users_options="users_options">
						</member-filter>
						<template #modal-footer="{ ok }">

							<div class="w-100">
								<!-- Emulate built in modal footer ok and cancel button actions -->
								<b-button @click="$bvModal.hide('modal-member')" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
									</span></b-button>
								<b-button @click="ok()" type="submit" :disabled="isSearching" class="akkurate-green-btn btn-size float-right border-0"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'search']" />Search</span></b-button>
							</div>
						</template>
					</b-modal>

				</div>
			</div>
			<footer></footer>
		</div>

		<all-account-statement :member_id="member_id" :institution="institution" />

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>

</template>

<script>
// import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";
import ApiService from "@/core/services/api.service";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";

import SendSmsForm from "../../sms/SendSmsForm.vue";
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import MemberFilter from "../forms/MemberFilter.vue";
import MemberView from '@/views/main/pages/member/view/MemberView.vue'
import 'vue-good-table/dist/vue-good-table.css';
import Multiselect from 'vue-multiselect'
import CustomTooltip from "@/views/components/CustomTooltip.vue";
import MapModal from "@/views/components/MapModal.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
import AllAccountStatement from "../accounts/statement/AllAccountStatement.vue";
// import $ from 'jquery';
// import 'datatables.net';
// import config from '@/config.js'
// import JwtService from "@/core/services/jwt.service";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		MemberFilter,
		MemberView,
		Multiselect,
		SendSmsForm,
		CustomTooltip,
		MapModal,
		ChatBot,
		AllAccountStatement,
	},
	computed: {
		// Count characters including spaces
		messageCharCount() {
			return this.sms_message ? this.sms_message.length : 0;
		},
		// Calculate how many SMS messages this will use (1 SMS = 160 chars)
		messageCount() {
			return Math.ceil(this.messageCharCount / 160) || 1;
		},
		// Calculate number of recipients (split by comma, trim, and filter out empty)
		recipientCount() {
			if (!this.recipient) return 0;
			return this.recipient
				.split(',')
				.map(num => num.trim())
				.filter(num => num.length > 0).length;
		},
	},

	data() {
		return {
			isSearching: false,
			digitalAddress: "",
			coords: null,
			selectedMemberInfo: {
				name: "Member",
				phone: "N/A",
				email: "N/A",
				status: "N/A",
			},
			status_option: ['Pending', 'Active', 'Inactive', "Dormant", "Closed"],
			trans_source_options: [
				{ name: 'USSD', value: "ussd" },
				{ name: 'OFFICE', value: "office" },
				{ name: 'MOBILE', value: "mobile" },
				// { name: 'Deposit', value: "deposit" },
				// { name: 'Withdrawal', value: "withdrawal" },
			],
			selected: 'custom',
			options: [
				{ text: 'Custom', value: 'custom' },
				{ text: 'Bulk', value: 'bulk' }
			],
			recipient: "",
			message: "",
			sms_message: "",
			users_options: [],
			member_id: "",
			selectedCustomerId: null,
			selectedCustomerPhoneHint: "",
			institution: {},
			totalRecords: 0,
			searchFilter: "",
			isBusy: true,
			branch: null,
			branch_option: [],
			currentPage: 1,
			perPage: 10,
			per_page_options: ['10', '20', '50', '100', '500', '1000', '5000', '10000'],
			per_page_selected: "10",
			disable_recipient: false,
			form: {
				status: "",
				search_term: "",
				from_date: "",
				to_date: "",
				trans_source: "",
				branch: "",
				start_date: "",
				end_date: "",
				gender: "",
				gender_option: ['Male', 'Female', 'Group'],
				users: []
			},

			fields: [
				{
					label: '#',
					key: 'index',
				},
				{
					label: 'Cust.Code',
					key: 'code',
				},
				{
					label: 'Old_Code',
					key: 'external_code',
				},
				{
					label: 'Fullname',
					key: 'customer',
				},
				{
					label: 'Email',
					key: 'email',
				},
				{
					label: 'Mobile',
					key: 'mobile',
				},
				{
					label: 'Source',
					key: 'source',
				},
				{
					label: 'Digital_Address',
					key: 'digital_address',
				},
				{
					label: 'Ghana_Card',
					key: 'ghana_card_number',
				},
				{
					label: 'Reg.Date',
					key: 'registered_date',
				},
				{
					label: 'Status',
					key: 'status',
				},
				{
					label: 'Actions',
					key: 'actions',
				},
			],
			rows: [],
		};
	},
	mounted() {
		let token = localStorage.getItem('token');
		if (!token) {
			this.$router.push({ path: '/login' });
		}
		this.getAccountDropdown();
		this.loadItems();
		this.getInsistution();

	},
	methods: {
		showMap(member) {

			this.digitalAddress = member.digital_address;
			this.coords = { lat: member.latitude, lng: member.longitude };

			this.selectedMemberInfo = {
				name: `${member.first_name} ${member.last_name}`,
				phone: member.mobile,
				email: member.email,
				status: member.status,
			};

			this.$bvModal.show('map-modal-1')
		},
		onRadioChange(value) {
			// Do something when a radio is selected
			if (value == 'bulk') {
				this.disable_recipient = true;
				this.recipient = "";
			} else {
				this.disable_recipient = false;
			}
		},

		handleOk(bvModalEvent) {
			// Prevent modal from closing
			// bvModalEvent.preventDefault();
			// Trigger submit handler
			this.filterTable()
		},
		statusBadge(item) {
			// console.log(item.status === 'Active');
			if (item.get_pending_request_member_edit.length > 0) {
				return 'badge akkurate-custom-mid-green'
			}
			if (item.status === 'Active') {
				return 'badge akkurate-green-bg'
			} else if (item.status === 'Inactive') {
				return 'badge akkurate-danger-bg'
			} else if (item.status === 'Dormant') {
				return 'badge akkurate-danger-bg'
			} else if (item.status === 'Pending') {
				return 'badge akkurate-warning-bg'
			} else {
				return 'badge akkurate-warning-bg'
			}
		},
		rowClass(item, type) {
			if (item?.get_pending_request_member_edit.length > 0) {
				return 'custom-row-height table-custom-light-green'
			} else {
				return 'custom-row-height'
			}

		},
		filterTable() {
			this.loadItems();
		},

		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadItems()
		},
		selectPerPage(index) {
			this.perPage = index
			this.loadItems()
		},
		showCustomerViewModal(id, institution) {
			this.member_id = id;
			this.institution = institution
			this.$bvModal.show('bv-modal-customer-view')
		},
		showAllStatementModal(id, institution,dt) {
			this.member_id = id;
			this.institution = institution
			// this.selectedCustomerNumber = mobileNumber;
			// console.log("SELECTED:", this.selectedCustomerNumber); // ✅ should show the right value

			this.$nextTick(() => {
				this.$bvModal.show("all_account_statement");
			});
		},
		showSendSmsModal(member) {
			if (!member || member.id == null) {
				return;
			}
			const id = Number(member.id);
			if (!Number.isFinite(id) || id < 1) {
				return;
			}
			this.selectedCustomerId = id;
			this.selectedCustomerPhoneHint = member.mobile || "";

			this.$nextTick(() => {
				this.$bvModal.show("send-mail-all");
			});
		},
		async sendSmsAll() {
			if (this.selected == 'bulk') {
				this.$Progress.start();
				this.isBusy = true;
				await ApiService.post(`/customers/sms/send/all`, {
					'message': this.sms_message,
				}).then((response) => {
					this.$Progress.finish();
					this.isBusy = false;
					swal.fire({
						// title: response.statusText,
						text: response.data.message,
						icon: "success",
						allowOutsideClick: true,
						allowEscapeKey: true,
						showCancelButton: false, // Show the "Cancel" button
						confirmButtonText: "okay", // Customize the text for the "OK" button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						},
					});
					this.loadItems();
				})
					.catch((error) => {
						this.$Progress.fail();
						this.isBusy = false;
						swal.fire({
							// title: response.statusText,
							text: error.response.data.message,
							icon: "error",
							allowOutsideClick: true,
							allowEscapeKey: true,
							showCancelButton: false,
							confirmButtonText: "okay",
							buttonsStyling: false,
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
						});
					}).finally(() => {
						this.$Progress.fail();
						this.isBusy = false;
					});

			} else {

				this.$Progress.start();
				this.isBusy = true;
				await ApiService.post(`/customers/sms/multiple/phones`, {
					'recipients': this.recipient,
					'message': this.sms_message,
				}).then((response) => {
					this.$Progress.finish();
					this.isBusy = false;
					swal.fire({
						// title: response.statusText,
						text: response.data.message,
						icon: "success",
						allowOutsideClick: true,
						allowEscapeKey: true,
						showCancelButton: false, // Show the "Cancel" button
						confirmButtonText: "okay", // Customize the text for the "OK" button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						},
					});
					this.loadItems();
				})
					.catch((error) => {
						this.$Progress.fail();
						this.isBusy = false;
						swal.fire({
							// title: response.statusText,
							text: error.response.data.message,
							icon: "error",
							allowOutsideClick: true,
							allowEscapeKey: true,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: "okay", // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
						});
					}).finally(() => {
						this.$Progress.fail();
						this.isBusy = false;
					});

			}

		},
		// async sendSmsAll() {

		// 	this.$Progress.start();
		// 	this.isBusy = true;
		// 	await ApiService.post(`/customers/sms/send/all`, {
		// 		'message': this.sms_message,
		// 	}).then((response) => {
		// 		this.$Progress.finish();
		// 		this.isBusy = false;
		// 		swal.fire({
		// 			// title: response.statusText,
		// 			text: response.data.message,
		// 			icon: "success",
		// 			allowOutsideClick: true,
		// 			allowEscapeKey: true,
		// 			showCancelButton: false, // Show the "Cancel" button
		// 			confirmButtonText: "okay", // Customize the text for the "OK" button
		// 			buttonsStyling: false, // Disable SweetAlert2 styling for buttons
		// 			customClass: {
		// 				confirmButton:
		// 					"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
		// 			},
		// 		});
		// 		this.loadItems();
		// 	}).catch((error) => {
		// 			this.$Progress.fail();
		// 			this.isBusy = false;
		// 			swal.fire({
		// 				// title: response.statusText,
		// 				text: error.response.data.message,
		// 				icon: "error",
		// 				allowOutsideClick: true,
		// 				allowEscapeKey: true,
		// 				showCancelButton: false, // Show the "Cancel" button
		// 				confirmButtonText: "okay", // Customize the text for the "OK" button
		// 				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
		// 				customClass: {
		// 					confirmButton:
		// 						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
		// 				},
		// 			});
		// 	}).finally(() => {
		// 			this.$Progress.fail();
		// 			this.isBusy = false;
		// 	});
		// },
		async getAccountDropdown() {
			this.$Progress.start();
			this.isBusy = true;
			await ApiService.get("/accounts/create/dropdown")
				.then((response) => {
					this.form.branch_option = response?.data?.branches
					this.form.acc_types_option = response?.data?.account_types
					this.users_options = response?.data?.users
					this.isBusy = false;
					this.$Progress.finish();
				}).catch((error) => {
					// console.log(error);
				})
		},
		// load items is what brings back the rows from server
		async loadItems() {
			this.isBusy = true;
			this.$Progress.start();  // Start the progress bar
			// console.log(this.form.users);
			await ApiService.post("customers/paginate",
				{
					"page": this.currentPage,
					"per_page": this.perPage,
					"filter": this.form.search_term,
					"branch_id": this.form.branch?.id,
					"status": this.form.status, //Inactive,	Active, Inactive, Dormant, Closed
					"source": this.form.trans_source,
					"start_date": this.form.start_date,
					"end_date": this.form.end_date,
					"region_id": null,
					"gender": this.form.gender,
					'users': this.form.users.map(index => index.id)
				}).then(response => {
					// Handle response and update table data
					this.isBusy = false;  // Set isBusy to false when the data is loaded
					this.$Progress.finish();  // Finish the progress bar
					this.rows = response.data.data;
					// console.log(this.rows)
					this.totalRecords = response.data.meta.total;

				}).catch(() => {
					this.isBusy = false;  // Set isBusy to false in case of an error
					this.$Progress.finish();  // Finish the progress bar even if there's an error
					return [];  // Return an empty array in case of error to prevent the table from breaking
				}).finally(() => {
					this.isBusy = false;  // Set isBusy to false in case of an error
					this.$Progress.finish();  // Finish the progress bar even if there's an error
				});
		},

		confirmDeleteUser(user) {
			swal.fire({
				title: "Disable User",
				text: `Are you sure you want to disable ${user.username}?`,
				icon: "warning",
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Ok",
				allowOutsideClick: false,
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
				},
			}).then((result) => {
				if (result.value) {
					//   window.location.reload();
				}
			});
		},

		deleteMember(data) {
			swal.fire({
				title: "Please confirm",
				html: `Are you sure you want to <strong>DELETE</strong> member <strong>${data.first_name} ${data.last_name}</strong>?<br/>This action cannot be reversed`,
				icon: "warning",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Delete", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-red-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$Progress.start();
					await ApiService.delete(`/customers/delete/${data.id}`)
						.then((response) => {
							// console.log(response);
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadItems();
						})
						.catch((error) => {
							this.$Progress.fail();
							// console.log(error);
							swal.fire({
								// title: response.statusText,
								text: error.response.data.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
					//
				}
			});
		},

		resetPIN(data) {
			swal.fire({
				title: "Reset Member PIN",
				html: `Are you sure you want to reset the PIN for member <strong>${data.first_name} ${data.last_name}</strong>?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes, Reset",
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
				},
				// allowOutsideClick: false
			}).then((result) => {
				if (result.value) {
					//   window.location.reload();
					//send put request to reset password
					ApiService.put(`customers/reset-pin/${data.id}`)
						.then((response) => {
							swal.fire({
								title: "Success",
								html: response.data.message,
								icon: "success",
								showCancelButton: false,
								confirmButtonColor: "#3085d6",
								cancelButtonColor: "#d33",
								confirmButtonText: "Ok",
								allowOutsideClick: false,
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						})
						.catch((error) => {
							swal.fire({
								title: "Error",
								text: error.response.data.message,
								icon: "error",
								showCancelButton: false,
								confirmButtonColor: "#3085d6",
								cancelButtonColor: "#d33",
								confirmButtonText: "Ok",
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
								// allowOutsideClick: false
							});
						});
				}
			});
		},

		approveEdit(data) {
			swal.fire({
				title: "Approve Edit",
				html: `Are you sure you want to Approve Edit For <strong>${data.first_name} ${data.last_name}</strong> ?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Approve",
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
				},
				// allowOutsideClick: false
			}).then((result) => {
				if (result.value) {
					//   window.location.reload();
					//send put request to reset password
					ApiService.put(`customers/approve-update/${data.id}`, {
						status: "approve", //approve,reject
						reject_reason: "",
					})
						.then((response) => {
							swal.fire({
								title: "Success",
								html: response.data.message,
								icon: "success",
								showCancelButton: false,
								confirmButtonColor: "#3085d6",
								cancelButtonColor: "#d33",
								confirmButtonText: "Ok",
								allowOutsideClick: false,
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadItems();
						})
						.catch((error) => {
							swal.fire({
								title: "Error",
								text: error.response.data.message,
								icon: "error",
								showCancelButton: false,
								confirmButtonColor: "#3085d6",
								cancelButtonColor: "#d33",
								confirmButtonText: "Ok",
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
								// allowOutsideClick: false
							});
						});
				}
			});
		},

		setUserStatus(status, data) {
			swal.fire({
				title: "Are you sure?",
				html:
					`You want to set member status to <strong>${status}</strong> for <strong>${data.first_name}` +
					` ${data.last_name}</strong>?`,
				icon: "warning",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Yes", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$Progress.start();
					await ApiService.put(
						`/customers/status-update/${data.id}`,
						{
							status: status,
						}
					)
						.then((response) => {
							// console.log(response);
							this.$Progress.finish();
							swal.fire({
								title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadItems();
						})
						.catch((error) => {
							this.$Progress.fail();
							// console.log(error);
						});
					//
				}
			});
		},

		viewData(data) {
			this.$router.push("/members/view/" + data.id);
			// console.log(id.id);
		},

		exportToExcel() {
			const workbook = XLSX.utils.book_new();

			// Get the table data
			const tableData = this.rows.map((row) => {
				return {
					member_code: row.code,
					name: `${row.first_name} ${row.middlename} ${row.last_name}`,
					mobile: row.mobile,
					address: row.address,
					date_of_birth: row.date_of_birth,
					registered_date: row.registered_date,
					gender: row.gender,
					branch: row.branch ? row.branch.name : "",
				};
			});

			// Convert the table data to a worksheet
			const worksheet = XLSX.utils.json_to_sheet(tableData);

			// Add the worksheet to the workbook
			XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

			// Generate the Excel file buffer
			const excelBuffer = XLSX.write(workbook, {
				type: "array",
				bookType: "xlsx",
			});

			// Save the Excel file
			FileSaver.saveAs(
				new Blob([excelBuffer], {
					type: "application/octet-stream",
				}),
				"table_data.xlsx"
			);
		},
		async getInsistution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		getMemInfo(data) {
			const fullName = [data.first_name, data.last_name].filter(Boolean).join(' ') || 'N/A';
			const gender = data.gender || 'N/A';
			const hometown = data.home_town || 'N/A';
			const statusText = data.status || 'N/A';
			const statusClass = this.statusBadge(data);
			const passport = data.passport_pic_path || '';
			const ghCard = data.gh_card_front_path || '';
			const signature = data.signature_image_path || '';

			const passportImg = passport ? `<img id="profile-picture" src="${passport}" alt="Member Profile" class="w-auto h-auto rounded-circle object-fit-cover mb-3 mb-sm-0 me-sm-2" style="width: 130px !important; height: 130px !important;">` : '';
			const ghCardImg = ghCard ? `<img src="${ghCard}" alt="Ghana Card Front" style="width: 170px !important;" class="img-fluid text-center gallery-image me-sm-2" />` : '';
			const signatureImg = signature ? `<img src="${signature}" alt="Signature" style="width: 170px !important;" class="img-fluid text-center gallery-image" />` : '';

			return `<div class="row">
					<div class="col-12">
						<div class="d-flex mt-2 justify-content-center align-items-center justify-content-lg-start gap-3 border-bottom border-gray-200 my-1 pb-1">
							<div class="text-center akkurate-extra-small text-sm-start">
								<h1 class="fs-6 fw-bold mb-1">${fullName}</h1>
								<p class="akkurate-small mb-1">Gender: <span class="fw-medium" id="member-id">${gender}</span></p>
								<p class="akkurate-small mb-1">Home town: <span class="fw-medium">${hometown}</span></p>
								<div class="d-flex align-items-center justify-content-center justify-content-sm-start gap-2">
									<span id="member-status-badge" class="${statusClass}">${statusText}</span>
								</div>
							</div>
						</div>
						<div class="col-12 d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-sm-start ">
							${passportImg}
							${ghCardImg}
							${signatureImg}
						</div>
					</div>
				</div>`
		},

		getLocationDisplayMessage(data) {
			return `
			<div>
				<span class="akkurate-small text-nowrap text-truncate d-flex align-items-center gap-2">
				<font-awesome-icon :icon="['fas', 'map-marker-alt']" />
			</span>
			Track ${data.first_name + " " + data.last_name}'s location:
				<br/>
				${data.digital_address ? data.digital_address : 'No Digital Address'} 
				${data.latitude && data.longitude ? `<a class="custom-pointer akkurate-dark" @click="showMap(data)"><font-awesome-icon :icon="['fas', 'map']" class="ms-2" /></a>` : ''}
			</div>
			`
		}
	},

};
</script>
